import { PICKUP_MANAGEMENT_MODES, FORM_VALIDATION_MSG } from "./constants";
import { convertDateTimeToTimeString } from "../../../../../dataGrid/gridUtilities";
import { format, addDays } from "date-fns";
import { getTerminalDateByOffset } from "../../../utils/utils";
import { getFilteredShipmentsData } from "./utils";
import { isNonEmptyShipmentObj } from "./ShipmentInfo/utils";

const PICKUP_MANAGEMENT_CONFIG = {
  [PICKUP_MANAGEMENT_MODES.CREATE_PICKUP]: {
    apiName: "CreatePickup",
    getRequestParams: ({ pickupData }) => {
      const { pickupInfo: formData, pickupTerminal, userProfile } = pickupData;
      return {
        pickupTerminal,
        shipper: {
          ...formData.shipperInfo,
          shipperContactPhone:
            formData.shipperInfo.shipperContactPhone.toString(),
          shipperSpecialInstructions : undefined
        },
        shipmentData: formData.shipmentInfo
          .filter(isNonEmptyShipmentObj)
          .map((shipment, index) => ({
            ...shipment,
            sequenceNumber: (index+1).toString(),
          })),
        ...getPickupDateTime(formData.pickupDateTimeInfo),
        ...formData.billingInfo,
        specialInstructions: formData.specialInstructions,
        isSwapPickup: formData.isSwapPickup,
        terminalCode: userProfile.terminal.code,
      };
    },
    getPickupDateError: (value, terminalOffset) => {
      if (!value) {
        return FORM_VALIDATION_MSG.REQUIRED;
      }
      if (
        new Date(value) <
        new Date(getTerminalDateByOffset(new Date(), terminalOffset))
      ) {
        return FORM_VALIDATION_MSG.MIN_PICKUP_DATE;
      }
      return null;
    }
  },
  [PICKUP_MANAGEMENT_MODES.EDIT_PICKUP]: {
    apiName: "EditPickup",
    getRequestParams: ({ pickupData }) => {
      const {
        pickupInfo: formData,
        pickupTerminal,
        pickupId,
        pickupNumber,
        isDateTimeUpdated,
        userProfile
      } = pickupData;
      return {
        shipper: {
          ...formData.shipperInfo,
          shipperContactPhone:
            formData.shipperInfo.shipperContactPhone.toString(),
          shipperSpecialInstructions : undefined
        },
        shipmentData: getFilteredShipmentsData(formData.shipmentInfo),
        ...getPickupDateTime(formData.pickupDateTimeInfo),
        ...formData.billingInfo,
        specialInstructions: formData.specialInstructions,
        isSwapPickup: formData.isSwapPickup,
        terminalCode: userProfile.terminal.code,
        editReasonInfo: isDateTimeUpdated
          ? {
              ...formData.editReasonInfo,
              ...(Boolean(formData.editReasonInfo.editReasonCode) && {
                editReasonCode: Number(formData.editReasonInfo.editReasonCode),
                callTime: convertDateTimeToTimeString(
                  formData.editReasonInfo.callTime
                ),
              }),
            }
          : null,
        pickupId,
        pickupNumber,
        pickupTerminal
      };
    },
    getPickupDateError: (value, terminalOffset) => {
      if (!value) {
        return FORM_VALIDATION_MSG.REQUIRED;
      }
      if (
        new Date(value) <
        new Date(getTerminalDateByOffset(new Date(), terminalOffset))
      ) {
        return FORM_VALIDATION_MSG.MIN_PICKUP_DATE;
      } else if (
        (new Date(value) >
          addDays(new Date(getTerminalDateByOffset(new Date(), terminalOffset)), 7))
      ) {
        return FORM_VALIDATION_MSG.MAX_PICKUP_DATE;
      }
      return null;
    }
  },
  [PICKUP_MANAGEMENT_MODES.MERGE_PICKUP] : {
    apiName: "MergePickup",
    getRequestParams: ({pickupData, selectedPickups, selectedDriver}) => {
      const { pickupInfo: formData, pickupTerminal, userProfile } = pickupData;
      return {
        shipper: {
          ...formData.shipperInfo,
          shipperContactPhone:
            formData.shipperInfo.shipperContactPhone.toString(),
          isAccountNumberDisabled: undefined,
          shipperSpecialInstructions : undefined
        },
        shipmentData: getFilteredShipmentsData(formData.shipmentInfo),
        ...getPickupDateTime(formData.pickupDateTimeInfo),
        ...formData.billingInfo,
        specialInstructions: formData.specialInstructions,
        isSwapPickup: formData.isSwapPickup,
        terminalCode: userProfile.terminal.code,
        pickupDriverMapping: selectedPickups.map(({ pickupId, driverId }) => ({
          pickupId,
          driverId,
        })),
        pickupNumbers: selectedPickups.map((pickup) => pickup.pickupNumber),
        driverIdToAssignPickup: selectedDriver,
        pickupTerminal
      };
    },
    getPickupDateError: (value, terminalOffset) => {
      if (!value) {
        return FORM_VALIDATION_MSG.REQUIRED;
      }
      if (
        new Date(value) <
        new Date(getTerminalDateByOffset(new Date(), terminalOffset))
      ) {
        return FORM_VALIDATION_MSG.MIN_PICKUP_DATE;
      } else if (
        new Date(value) >
        addDays(
          new Date(getTerminalDateByOffset(new Date(), terminalOffset)),
          7
        )
      ) {
        return FORM_VALIDATION_MSG.MAX_PICKUP_DATE;
      }
      return null;
    }
  }
};

const getPickupDateTime = ({ readyTime, closeTime, pickupDate, route }) => {
  return {
    readyTime: convertDateTimeToTimeString(readyTime),
    closeTime: convertDateTimeToTimeString(closeTime),
    pickupDate: format(pickupDate, "yyyy-MM-dd"),
    route
  };
};

export { PICKUP_MANAGEMENT_CONFIG };
